import {Component, Input, OnInit} from '@angular/core';
import {BaseTileComponent} from '../tile.component';
import {LicenseService} from '../../../services/license.service';
import {EnvironmentService} from '../../../services/environment.service';

@Component({
  selector: 'itpx-google-slides-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.css']
})
export class TileComponent extends BaseTileComponent {

  @Input() deliverable: any;
  images: string;
  href: string = '#';

  constructor(private licenseService: LicenseService,
              private environmentService: EnvironmentService) {
    super();
    this.images = this.environmentService.config['server'].images;
  }

  ngOnInit() {
    super.init(this.licenseService, this.deliverable, false);
    this.href = `/#/app/gslides/${this.deliverable.assignmentId}/${this.deliverable.id}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/google-slides/tile.component.ts